import { useState } from "react";
import { supabase } from "../supabaseClient";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";

export default function Register() {
    const [form, setForm] = useState({ email: "", password: "", full_name: "", phone: "" });
    const [yukleniyor, setYukleniyor] = useState(false);
    const [tamamlandi, setTamamlandi] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setYukleniyor(true);
        const { error } = await supabase.auth.signUp({
            email: form.email,
            password: form.password,
            options: {
                data: {
                    full_name: form.full_name,
                    phone: form.phone,
                }
            }
        });
        if (error) {
            toast.error(error.message);
        } else {
            setTamamlandi(true);
        }
        setYukleniyor(false);
    };

    if (tamamlandi) return (
        <div style={styles.container}>
            <div style={styles.kart}>
                <h2 style={{textAlign:"center", color:"#16a34a"}}>✅ Kayıt Tamamlandı!</h2>
                <p style={{textAlign:"center", color:"#555"}}>
                    <strong>{form.email}</strong> adresine doğrulama maili gönderdik.
                    Lütfen mailinizi kontrol edin.
                </p>
                <Link to="/giris" style={styles.butonLink}>Giriş Sayfasına Git</Link>
            </div>
        </div>
    );

    return (
        <div style={styles.container}>
            <div style={styles.kart}>
                <h1 style={styles.baslik}>📈 Borsa Analiz</h1>
                <h2 style={styles.altBaslik}>Kayıt Ol</h2>
                <form onSubmit={handleSubmit}>
                    <input style={styles.input} type="text"     placeholder="Ad Soyad" value={form.full_name} onChange={e => setForm({...form, full_name: e.target.value})} required />
                    <input style={styles.input} type="email"    placeholder="Email"    value={form.email}     onChange={e => setForm({...form, email: e.target.value})}     required />
                    <input style={styles.input} type="tel"      placeholder="Telefon (05xx...)" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} required />
                    <input style={styles.input} type="password" placeholder="Şifre (min 6 karakter)" value={form.password} onChange={e => setForm({...form, password: e.target.value})} required minLength={6} />
                    <button style={styles.buton} type="submit" disabled={yukleniyor}>
                        {yukleniyor ? "Kaydediliyor..." : "Kayıt Ol"}
                    </button>
                </form>
                <p style={styles.link}>
                    Zaten üye misin? <Link to="/giris">Giriş yap</Link>
                </p>
            </div>
        </div>
    );
}

const styles = {
    container:  { display:"flex", justifyContent:"center", alignItems:"center", height:"100vh", background:"#f0f2f5" },
    kart:       { background:"white", padding:"2rem", borderRadius:"12px", width:"380px", boxShadow:"0 4px 20px rgba(0,0,0,0.1)" },
    baslik:     { textAlign:"center", color:"#1a1a2e", marginBottom:"0.25rem" },
    altBaslik:  { textAlign:"center", color:"#555", fontWeight:"normal", marginBottom:"1.5rem" },
    input:      { width:"100%", padding:"0.75rem", marginBottom:"1rem", border:"1px solid #ddd", borderRadius:"8px", fontSize:"14px", boxSizing:"border-box" },
    buton:      { width:"100%", padding:"0.75rem", background:"#2563eb", color:"white", border:"none", borderRadius:"8px", fontSize:"16px", cursor:"pointer" },
    butonLink:  { display:"block", textAlign:"center", padding:"0.75rem", background:"#2563eb", color:"white", borderRadius:"8px", textDecoration:"none", marginTop:"1rem" },
    link:       { textAlign:"center", marginTop:"1rem", color:"#555", fontSize:"14px" },
};